import { useState, useCallback } from 'react';

const STORAGE_PREFIX = 'analytics-collapsed-';

export function useCollapsibleState(sectionId: string): [boolean, () => void] {
  const key = `${STORAGE_PREFIX}${sectionId}`;

  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(key) === 'true';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(key, String(next));
      } catch {
        // localStorage unavailable — state still works in-memory
      }
      return next;
    });
  }, [key]);

  return [collapsed, toggle];
}
